<template>
  <div class="home">
    <span class="desc">Domowe zużycie energii</span>
    <div class="home__box">
      <ul class="home__list">
        <li class="home__list__item" v-for="(item, index) in devices" v-bind:key="index">
          <button class="home__list__button" v-bind:class="{'active': item.active }" v-on:click="switchDevice(item)">
            <div class="home__list__icon-box">
              <div class="home__list__icon">
                <LampSvg v-if="item.slug == 'lamp'" />
                <TvSvg v-if="item.slug == 'tv'" />
                <FridgeSvg v-if="item.slug == 'fridge'" />
                <WMSvg v-if="item.slug == 'wm'" />
                <OwenSvg v-if="item.slug == 'owen'" />
              </div>
              <div class="home__list__name">{{ item.name }}</div>
            </div>
            <span class="home__list__label">
              {{ item.power }}W
            </span>
          </button>
        </li>
      </ul>
      <div class="home__footer">
        <span class="home__footer__icon">
          <OnSvg />
        </span>
        <p>Włącz urządzenia i zobacz jak zużycie energii wpływa na instaltację fotowoltaiczną.</p>
      </div>
    </div>
  </div>
</template>

<script>
import OnSvg from '@/assets/icon/on.svg';
import LampSvg from '@/assets/icon/lamp.svg';
import TvSvg from '@/assets/icon/tv.svg';
import FridgeSvg from '@/assets/icon/fridge.svg';
import WMSvg from '@/assets/icon/wm.svg';
import OwenSvg from '@/assets/icon/owen.svg';

export default {
  name: "Home",
  data() {
    return {
      devices: []
    }
  },
  components: {
    OnSvg,
    LampSvg,
    TvSvg,
    FridgeSvg,
    WMSvg,
    OwenSvg,
  },
  props:{
    config: Object
  },
  created() {
    this.config.home.forEach((item) => {
      this.devices.push({
        slug: item.slug,
        name: item.name,
        power: item.power,
        active: item.active,
      });
    });
  },
  computed: {
    power: function(){ return this.calcPower(); }
  },
  methods: {
    calcPower(){
      let results = 0;
      this.devices.forEach((item) => {
        results += item.active ? item.power : 0;
      });
      return results;
    },
    switchDevice(item){
      item.active = ! item.active;

      this.$emit('change-power', this.calcPower());
    }
  }

}
</script>

<style lang="scss">

#photovoltaics {
  .home {
    //background: #0f0;
    min-height: 150px;
    grid-column: 1 / 3;
    grid-row: 6;
    margin-top: 2rem;

    @include media-breakpoint-up(md) {
      margin-top: 0;
      grid-row: 4;
      grid-column: 1 / span 2;
    }
    @include media-breakpoint-up(lg) {
      grid-column: 1;
    }

    &__box{
      background: $white;
      border: 1px solid $lightgray;
      border-radius: 5px;
      box-shadow: 0 3px 10px rgba(128,128,128,0.2);
      padding: 10px;
    }

    &__list{
      list-style: none;
      padding-left: 0;
      display: flex;
      flex-direction: column;
      &__item{
      }
      &__icon-box{
        display: flex;
        //flex: 1;
      }
      &__icon{
        margin-right: 20px;
        width: 40px;
      }
      &__name{
        align-self: center;
        font-size: 14px;
      }
      &__label{
        background: $lightgray;
        padding: 1.6px 8px;
        border-radius: 1rem;
        display: inline-block;
        align-self: center;
        font-size: 12px;
      }
      &__button{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        border: 1px solid $lightgray;
        background: $white;
        border-radius: 5px;
        margin-bottom: 10px;
      }
      @include media-breakpoint-up(md) {
        flex-direction: row;
        &__item{
          flex-grow: 1;
          width: 20%;
          padding-left: 5px;
          padding-right: 5px;

          &:before {
            content:'';
            float:left;
            padding-top:100%;
          }
        }

        &__button{
          flex-direction: column;
          justify-content: center;
          align-content: center;
          width: 100%;
          align-self: center;
          margin-bottom: 0;
        }
        &__icon-box{
          justify-content: center;
        }
        &__icon{
          margin-right: inherit;
          margin-bottom: 2px;
          width: 100%;
          padding-left: 0;
          padding-right: 0;
          svg{
            width: 100%;
          }
        }
        &__name{
          display: none;
        }
      }
      @include media-breakpoint-up(lg) {
        &__icon{
        }
      }
      @include media-breakpoint-up(xl) {
        &__icon{
          margin-bottom: 7px;
          padding-left: 7px;
          padding-right: 7px;
        }
      }
    }
    &__footer{
      display: flex;
      &__icon{
        display: flex;
        padding: 7px;
        align-self: center;
        width: 32px;
        border-radius: 50%;
        background: $yellow-light;
        margin-right: 1rem;

        svg{
          //width: 100%;
          //height: auto;
        }
      }
      p{
        font-size: 12px;
        margin-bottom: 0;
        color: $yellow-gradient-right;
      }
    }
  }


  .home__list__button{
    padding: 5px;
    &.active{
      border: 2px solid $greenblue;
      padding: 4px;
      background: rgba($greenblue, 0.05);
      svg path{
        fill: $greenblue;
      }
      .home__list__name{
        color: $greenblue;
      }
      .home__list__label{
        background: $greenblue;
        color: $white;
      }
    }
  }
}
</style>
